import React, { Dispatch, PropsWithChildren, SetStateAction } from 'react'

import { AiScriptDisplay } from '../video/factor/AiScriptDisplay'
import { SubtitleDisplay } from '../video/factor/subtitle'
import { BgmDisplay } from '../video/factor/BgmDisplay'

import { PriceDisplay } from '../video/factor/PriceDisplay'

import {
  Control,
  UseFormSetValue,
  UseFormWatch,
  UseFormTrigger,
  FieldErrors,
} from 'react-hook-form'
import { FormValues } from 'utils/type'
import { Me } from 'service/user'
import {
  AIRecommendProductShortTitleType,
  AiThumbnailTitle,
  BgmFactor,
  LinkDetailType,
  PromptGroup,
  SubtitleColorType,
  SubtitleType,
  ThumbnailType,
  VoiceGroupFactor,
  VoiceTagType,
} from 'service/list'
import { PurchaseGuideDisplay } from '../video/factor/PurchaseGuideDisplay'
import { TemplateSelector } from '../video/factor/template-selector/shortform'
import useGetProductTemplate from 'hooks/query/useGetProductTemplate'
interface FastcutShortformEffectSelectorProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  errors: FieldErrors<FormValues>
  trigger: UseFormTrigger<FormValues>
  userInfo: Me
  translatePlanName: (planName: string) => string
  error: any
  setError: Dispatch<SetStateAction<any>>
  isOpenLinkMethod: boolean
  selectedLinks: LinkDetailType[]
  aiRecommendThumbnailTitle: AiThumbnailTitle | null
  placIdThumbnail: { id: number; path: string }[]
  setPlacIdThumbnail: Dispatch<SetStateAction<{ id: number; path: string }[]>>
  isSaveThumbnail: boolean
  setIsSaveThumbnail: Dispatch<SetStateAction<boolean>>
  thumbNailDivRef: React.MutableRefObject<HTMLDivElement | null>
  selectedPlacIdThumbnail: { id: number; path: string } | null
  setSelectedPlacIdThumbnail: Dispatch<
    SetStateAction<{ id: number; path: string } | null>
  >
  selectedItem: ThumbnailType | null
  setSelectedItem: Dispatch<SetStateAction<ThumbnailType | null>>
  promptGroup: PromptGroup[] | undefined
  voiceList: VoiceGroupFactor[] | undefined
  userVoiceList: VoiceGroupFactor[] | undefined
  setPromptStatus: Dispatch<SetStateAction<boolean[]>>
  setVoicePlaying: Dispatch<SetStateAction<boolean[]>>
  setToneTooltip: Dispatch<SetStateAction<boolean[]>>
  promptStatus: boolean[]
  voicePlaying: boolean[]
  toneTooltip: boolean[]
  voiceTags: VoiceTagType | undefined
  userVoiceRefetch: any
  subTitleList: SubtitleType[] | []
  subtitleColorList: SubtitleColorType[] | []
  subtitleDivRef?: React.MutableRefObject<HTMLDivElement | null>
  bgmList: BgmFactor[] | []
  bgmRefs: React.MutableRefObject<(HTMLAudioElement | null)[]>
  setBgmPlaying: Dispatch<SetStateAction<boolean[]>>
  bgmPlaying: boolean[]
  handleBgmPlayButtonClick: (status: boolean, index: number) => void

  subtitleFontList: SubtitleColorType[] | []
  subtitleSizeList: SubtitleColorType[] | []
}
const FastcutShortformEffectSelector = ({
  watch,
  setValue,
  control,
  trigger,
  userInfo,
  translatePlanName,
  promptGroup,
  setPromptStatus,
  promptStatus,
  voiceList,
  userVoiceList,
  setVoicePlaying,
  voicePlaying,
  voiceTags,
  setToneTooltip,
  toneTooltip,
  userVoiceRefetch,
  subTitleList,
  subtitleColorList,
  subtitleDivRef,
  bgmList,
  bgmRefs,
  setBgmPlaying,
  bgmPlaying,
  handleBgmPlayButtonClick,
  errors,
  selectedLinks,
  subtitleFontList,
  subtitleSizeList,
}: PropsWithChildren<FastcutShortformEffectSelectorProps>) => {
  const { data: templateList } = useGetProductTemplate()
  return (
    <div className="">
      {' '}
      {/* 템플릿 선택 */}
      <div className="mb-10">
        {' '}
        <TemplateSelector
          watch={watch}
          errors={errors}
          setValue={setValue}
          control={control}
          trigger={trigger}
          translatePlanName={translatePlanName}
          userInfo={userInfo}
          templateList={templateList}
          selectedLink={selectedLinks[0]}
        />
      </div>
      {/* 상품가격정보 넣기/빼기   */}
      <PriceDisplay
        watch={watch}
        setValue={setValue}
        control={control}
        userInfo={userInfo}
      />
      {/* 목소리  */}
      <AiScriptDisplay
        watch={watch}
        setValue={setValue}
        control={control}
        translatePlanName={translatePlanName}
        userInfo={userInfo}
        promptGroup={promptGroup}
        setPromptStatus={setPromptStatus}
        promptStatus={promptStatus}
        voiceList={voiceList}
        userVoiceList={userVoiceList}
        setVoicePlaying={setVoicePlaying}
        voicePlaying={voicePlaying}
        voiceTags={voiceTags}
        setToneTooltip={setToneTooltip}
        toneTooltip={toneTooltip}
        userVoiceRefetch={userVoiceRefetch}
      />
      <SubtitleDisplay
        subTitleList={subTitleList ?? []}
        subtitleColorList={subtitleColorList ?? []}
        watch={watch}
        control={control}
        setValue={setValue}
        userInfo={userInfo}
        translatePlanName={translatePlanName}
        subtitleDivRef={subtitleDivRef}
        subtitleFontList={subtitleFontList}
        subtitleSizeList={subtitleSizeList}
      />
      {/* BGM  선택   */}
      <BgmDisplay
        bgmList={bgmList ?? []}
        setBgmPlaying={setBgmPlaying}
        bgmPlaying={bgmPlaying}
        watch={watch}
        setValue={setValue}
        translatePlanName={translatePlanName}
        bgmRefs={bgmRefs}
        handleBgmPlayButtonClick={handleBgmPlayButtonClick}
        userInfo={userInfo}
        control={control}
      />
      {/* 상품 구매 방법 안내 넣기/빼기   */}
      <PurchaseGuideDisplay
        watch={watch}
        setValue={setValue}
        control={control}
        userInfo={userInfo}
      />
    </div>
  )
}

export default FastcutShortformEffectSelector
